exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heroicon-bell .heroicon-outline{fill:#303034}.heroicon-bell .heroicon-component-fill{fill:#f7f7f8}.heroicon-bell .heroicon-component-accent{fill:#8b9397}.heroicon-bell .heroicon-shadows{fill:#303034;opacity:.4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-39af87e4","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Icons/NotificationIcon.vue
// module id = ik7+
// module chunks = 0